import React from 'react';
import { Stack, TableCell, TableRow, Typography } from '@mui/material';

export default function EmptyRow({ colSpan, icon, text }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ border: 'none' }}>
        <Stack spacing={0.5} alignItems="center" sx={{ py: 3, color: 'text.disabled' }}>
          {icon}
          <Typography variant="body2">{text}</Typography>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
